<template>
  <div class="page_invoiceSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="法务主体" size="small">
              <el-select filterable v-model="listQuery.subjectOfLegalAffairsId" placeholder="" size="small" clearable style="width: 180px;">
                <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="业务类型" size="small" v-if="activeName=='first'">
              <el-select v-model="listQuery.businessTypeId" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="类型" size="small" v-if="activeName=='second'">
              <el-select v-model="listQuery.strUserName" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option value="专票">专票</el-option>
                <el-option value="普票">普票</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="介质" size="small" v-if="activeName=='second'">
              <el-select v-model="listQuery.strUserName" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option value="数电">数电</el-option>
                <el-option value="电子">电子</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票方式" size="small" v-if="activeName=='first'">
              <el-select v-model="listQuery.billingMethod" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option label="全额征税" :value="1"></el-option>
                <el-option label="差额征税-差额开票" :value="2"></el-option>
                <el-option label="差额征税-全额开票" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态:" v-if="activeName=='first'">
              <el-select filterable v-model="listQuery.status" placeholder="" size="small" clearable style="width: 180px;">
                <el-option label="启用" :value="0"></el-option>
                <el-option label="停用" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt cp" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
      </div>
    </div>
    <!-- <el-collapse-transition> -->
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
          <el-form-item label="税收分类编码:" v-if="activeName=='first'" label-width="117px">
            <el-input v-model="listQuery.taxClassificationCode" size="small" clearable style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="一级分类:" v-if="activeName=='first'">
            <el-input v-model="listQuery.primaryClassification" size="small" clearable style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="发票品名:" v-if="activeName=='first'">
            <el-input v-model="listQuery.InvoicingName" size="small" clearable style="width: 180px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
        <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- v-if="checkPermission(['publicResources_page_list'],permissionLists)" -->
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab" class="s_tabs_box">
          <el-tab-pane :disabled="tableLoading" label="开票项目设置" name="first" v-if="checkPermission(['invoiceSet_invoiceSetTab'], permissionLists)"></el-tab-pane>
          <el-tab-pane :disabled="tableLoading" label="票种设置" name="second" v-if="checkPermission(['invoiceSet_ticketTypeSet'], permissionLists)"></el-tab-pane>
          <el-tab-pane :disabled="tableLoading" label="其他设置" name="third" v-if="checkPermission(['invoiceSet_otherSet'], permissionLists)"></el-tab-pane>
        </el-tabs>
        <div class="r_act_box">
          <div class="r_act_left" style="padding-left:20px;margin-bottom:15px">
            <div class="r_act_item" v-if="activeName=='first'">
              <el-button size="small" type="primary" @click="addJumpHandle" v-if="checkPermission(['invoiceSet_invoiceSetTab_add'], permissionLists)">+ 新增</el-button>
              <el-button size="small" type="success" @click="stopMulHandle(0)" v-if="checkPermission(['invoiceSet_invoiceSetTab_stopHandle'], permissionLists)">启用</el-button>
              <el-button size="small" type="warning" @click="stopMulHandle(1)" v-if="checkPermission(['invoiceSet_invoiceSetTab_stopHandle'], permissionLists)">停用</el-button>
            </div>
            <div class="r_act_item" v-if="activeName=='second'">
              <el-button size="small" type="primary" @click="addHandle" v-if="checkPermission(['invoiceSet_ticketTypeSet_add'], permissionLists)">+ 新增票种</el-button>
              <el-button size="small" type="success" @click="stopMulHandle(0)" v-if="checkPermission(['invoiceSet_ticketTypeSet_stopHandle'], permissionLists)">启用</el-button>
              <el-button size="small" type="warning" @click="stopMulHandle(1)" v-if="checkPermission(['invoiceSet_ticketTypeSet_stopHandle'], permissionLists)">停用</el-button>
            </div>
            <div class="r_act_item" v-if="activeName=='third'">
              <el-button size="small" type="primary" @click="addSupLeg" v-if="checkPermission(['invoiceSet_otherSet_add'], permissionLists)"> 新增</el-button>
            </div>
          </div>
          <div class="r_act_right"></div>
        </div>
        <el-table ref="multipleTable" class="doc_table" border v-loading="tableLoading" @selection-change="handleSelectionChange" :max-height="tableHeight-100" :data="tableData" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <div v-if="activeName=='first'">
            <el-table-column min-width="60" prop="status" label="状态" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="200" prop="subjectOfLegalAffairs" label="法务主体" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="100" prop="businessType" label="业务类型" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="100" prop="billingMethodNames" label="开票方式" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="100" prop="ticketType" label="适用票种" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="160" prop="taxClassificationCode" label="税收分类编码" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="120" prop="primaryClassification" label="一级分类" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="100" prop="invoicingName" label="发票品名" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column align="center" label="操作" fixed="right" width="160px" class-name="re_act_box">
              <template slot-scope="{row}">
                <div class="eleTabBtn">
                  <el-button type="text" size="small" plai @click="editJumpHandle(row,'view')">查看</el-button>
                  <el-button type="text" size="small" plai @click="editJumpHandle(row,'edit')" v-if="checkPermission(['invoiceSet_invoiceSetTab_edit'], permissionLists)">编辑</el-button>
                  <el-button type="text" size="small" @click="stopHandle([row.billingItemId],row.status=='启用' ? 1 : 0)" v-if="checkPermission(['invoiceSet_invoiceSetTab_stopHandle'], permissionLists)">{{row.status=='启用' ? '停用' : '启用'}}</el-button>
                </div>
              </template>
            </el-table-column>
          </div>

          <div v-if="activeName=='second'">
            <el-table-column min-width="100" prop="status" label="状态" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="160" prop="subjectOfLegalAffairsName" label="法务主体" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="100" prop="ticketType" label="介质" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="100" prop="type" label="专票/普票" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="100" label="操作" align="center" fixed="right">
              <template slot-scope="{row}">
                <div class="eleTabBtn">
                  <el-button type="text" @click="editTicketType(row)" v-if="checkPermission(['invoiceSet_ticketTypeSet_edit'], permissionLists)">编辑</el-button>
                  <el-button type="text" size="small" @click="stopHandle([row.id],row.status=='启用中' ? 1 : 0)" v-if="checkPermission(['invoiceSet_ticketTypeSet_stopHandle'], permissionLists)">{{row.status=='启用中' ? '停用' : '启用'}}</el-button>
                </div>
              </template>
            </el-table-column>
          </div>

          <div v-if="activeName=='third'">
            <el-table-column width="100" prop="status" label="序号" align="center">
              <template slot-scope="{$index}">{{ $index + 1 }}</template>
            </el-table-column>
            <el-table-column min-width="200" prop="strLegalsubName" label="法务主体" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column min-width="100" prop="status" label="状态" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.status == 0 ? '启用' : '停用' }}</template>
            </el-table-column>
            <el-table-column min-width="100" label="操作" align="center">
              <template slot-scope="{row}">
                <div class="eleTabBtn">
                  <el-button type="text" @click="editSub(row)" v-if="checkPermission(['invoiceSet_otherSet_edit'], permissionLists)">编辑</el-button>
                  <el-button type="text" size="small" @click="stopHandleSub(row.subjectOfLegalAffairsId,row.status==0 ? 1 : 0)" v-if="checkPermission(['invoiceSet_otherSet_stopHandle'], permissionLists)">{{row.status==0 ? '停用' : '启用'}}</el-button>
                </div>
              </template>
            </el-table-column>
          </div>

        </el-table>
        <div class="block">
          <el-pagination v-if="activeName!='third'" @current-change="handleCurrentChange" :current-page.sync="listQuery.currpage" :page-size="listQuery.perpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增/修改弹框 -->
    <el-dialog :title="stateTitle" :visible.sync="ticketVisible" width="500px" class="res_dialog income_dialog">
      <el-form :rules="incomeRules" ref="statementForm" :model="ticketQuery" label-width="90px">
        <el-form-item label="法务主体:" prop="subjectOfLegalAffairsId">
          <el-select v-model="ticketQuery.subjectOfLegalAffairsId" placeholder="" size="small" filterable clearable>
            <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="票种:" prop="ticketType">
          <el-select v-model="ticketQuery.ticketType" placeholder="" size="small" clearable>
            <el-option value="数电"></el-option>
            <el-option value="电子"></el-option>
            <el-option value="纸质"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专票/普票:" prop="type">
          <el-select v-model="ticketQuery.type" placeholder="" size="small" clearable>
            <el-option value="专票"></el-option>
            <el-option value="普票"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用:" prop="status">
          <el-radio-group v-model="ticketQuery.status">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ticketVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveTicketHandle" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="stateTitle" :visible.sync="visibleSupLeg" width="500px" class="res_dialog income_dialog">
      <el-form label-width="90px">
        <el-form-item label="法务主体:" prop="subjectOfLegalAffairsId">
          <el-select v-model="subForm.subjectOfLegalAffairsId" placeholder="" size="small" filterable clearable>
            <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleSupLeg = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddSupLeg" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    row
  } from "mathjs";
  import xz from "./../../common";
  import FUN from "./../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  // import ResourceComTabs from "./components/resourceComTabs.vue"
  export default {
    components: {
      // ResourceComTabs
    },
    data() {
      return {
        pageTitle: '开票项目设置',
        // 弹框
        importVisible: false,
        needLoading: false,
        // 员工参数
        departMemberQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        },
        originList: [],
        // 部门参数
        departQuery: {
          strorgancode: '',
          roletype: ''
        },
        departMemberQuery: {
          keyword: '',
          strWorkState: '在职',
          currpage: 1,
          perpage: 100000
        },
        // 人员列表
        memberList: [],
        // 自定义 级联选择props
        propPosition: {
          label: 'strParametername',
          value: 'strParameterid',
          children: 'children',
          checkStrictly: true
        },
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        tableHeight: 0,
        showDropScreen: -1,
        activeName: 'first',
        // 列表参数
        listQuery: {
          subjectOfLegalAffairsId: "",
          businessTypeId: "",
          billingMethod: null,
          taxClassificationCode: "",
          primaryClassification: "",
          InvoicingName: '',
          status: 0,
          pagination: {
            page: 1,
            pageSize: 10,
            orders: []
          }
        },
        // 导出参数
        exportQuery: {},
        switchBtn: true,
        canvasImg: './../../../assets/images/qrcode.png',
        tableLoading: false,
        tableData: [],
        isCanHandle: true,
        totalCount: 0,
        multipleSelection: [],
        roleType: localStorage.loginRoletype,
        imgPath: this.$store.state.EMP.imgPath,
        btnLoading: false,
        // 是否能点击搜索按钮
        isSearchHandle: false,
        // 按钮权限参数
        butQuery: {
          path: '/invoiceSet',
          powerEnName: 'invoiceSet'
        },
        permissionLists: [],
        sheetList: [], //核算单编号
        // 项目列表
        projectList: [],
        // 项目名称列表参数
        proNameQuery: {
          searchVal: '',
          pageSize: 100000000,
          pageNum: 1
        },
        dedpartVal: [], //服务部门
        dedpartDiaVal: [], //归属部门
        ticketVisible: false,
        ticketQuery: {
          id: '',
          subjectOfLegalAffairsId: '', //法务主体
          ticketType: '', //票种
          type: '', //专票/普票
          status: 0, //是否启用
          founder: Cookies.get("userid-b"), //创建人
        },
        legList: [],
        isBtnLoading: false,
        incomeRules: { //规则
          'subjectOfLegalAffairsId': {
            required: true,
            message: '请选择法务主体',
            trigger: 'change'
          },
          'ticketType': {
            required: true,
            message: '请选择票种',
            trigger: 'change'
          },
          'type': {
            required: true,
            message: '请选择专票/普票',
            trigger: 'change'
          },
          'status': {
            required: true,
            message: '请选择是否启用',
            trigger: 'change'
          },
        },
        stateTitle: '新增票种',
        subForm: {
          subjectOfLegalAffairsId: '',
          status: '', //状态1：停用0：启用
          founder: Cookies.get("userid-b")
        },
        visibleSupLeg: false,
      }
    },
    created() {
      this.getlegalsubjectlist();
      this.getButtonPower()
      this.calHeight()
      this.getProNameList() //项目列表
      // 人员列表
      this.getMemberList()
      this.getList();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          this.getList()
          this.needLoading = false;
        } else {}
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          keyWord: '',
          pageSize: '10000',
          UserId: Cookies.get("userid-b")
        }
        xz.BasicFun(data, 'GetSubjectOfLegalAffairs').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      // 新增开票项目
      addJumpHandle() {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/addInvoice",
          query: {
            type: 'add'
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      // 编辑开票项目
      editJumpHandle(row, type) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/addInvoice",
          query: {
            id: row.billingItemId,
            type
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      // 新增显示弹框
      addHandle() {
        this.stateTitle = '新增票种';
        this.ticketQuery = {
          id: '',
          subjectOfLegalAffairsId: '', //法务主体
          ticketType: '', //票种
          type: '', //专票/普票
          status: 0, //是否启用
          founder: Cookies.get("userid-b"), //创建人
        }
        this.ticketVisible = true
      },
      // 确定保存
      saveTicketHandle() {
        this.isBtnLoading = true;
        xz.BasicFun(this.ticketQuery, 'SetTicketTypeSave').then(res => {
          try {
            if (res.status == 'ok') {
              this.$message.success('保存成功！');
              this.isBtnLoading = false;
              this.ticketVisible = false;
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
              this.getList();
            }
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错');
            this.isBtnLoading = false;
          }
        })
      },
      // 停用
      stopHandle(ids, status) {
        this.tableLoading = true;
        let data = {
          ids,
          status
        }
        let pagename = this.activeName == 'first' ? 'SetBillingItemChangeAsStatus' : 'SetTicketTypeChangeAsStatus';
        xz.BasicFun(data, pagename).then(res => {
          try {
            if (res.status == 'ok') {
              this.$message.success('修改成功！')
              this.tableLoading = false;
              this.getList();
            } else {
              this.$message.error(res.msg)
              this.tableLoading = false;
              this.getList();
            }
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错')
            this.tableLoading = false;
          }
        })
      },
      // 批量停用/启用
      stopMulHandle(status) {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(element => {
            if (this.activeName == 'second') {
              arr.push(element.id)
            } else {
              arr.push(element.billingItemId)
            }
          });
          this.stopHandle(arr, status);
        } else {
          this.$message.warning('请至少选择一个')
        }
      },
      editTicketType(row) {
        this.stateTitle = '编辑票种';
        xz.GetTicketTypeEdit(row.id).then(res => {
          if (res.status == 'ok') {
            this.ticketQuery = {
              id: row.id,
              subjectOfLegalAffairsId: res.data[0].subjectOfLegalAffairsId, //法务主体
              ticketType: res.data[0].ticketType, //票种
              type: res.data[0].type, //专票/普票
              status: res.data[0].status, //是否启用
              founder: Cookies.get("userid-b")
            }
            this.ticketVisible = true
          }
        })

      },
      changeTab() {
        if (this.activeName == 'first') {
          this.pageTitle = '开票项目设置';
          this.listQuery = {
            subjectOfLegalAffairsId: "",
            businessTypeId: "",
            billingMethod: null,
            taxClassificationCode: "",
            primaryClassification: "",
            InvoicingName: '',
            status: 0,
            pagination: {
              page: 1,
              pageSize: 10,
              orders: []
            }
          }
          this.getList();
        } else if (this.activeName == 'second') {
          this.pageTitle = '票种设置';
          this.listQuery = {
            pagination: {
              page: 1,
              pageSize: 10,
              orders: []
            },
            subjectOfLegalAffairsId: "",
            type: "",
            ticketType: ""
          }
          this.getList();
        } else if (this.activeName == 'third') {
          this.getList();
        }

      },
      getList() {
        if (this.activeName != 'third') {
          this.tableLoading = true;
          let pagename = this.activeName == 'first' ? 'GetBillingItemList' : 'GetTicketTypeList'
          xz.BasicFun(this.listQuery, pagename).then(res => {
            if (res.status == 'ok') {
              this.tableData = res.data.data;
              this.totalCount = res.data.totalCount;
              this.tableLoading = false;
            } else {
              this.tableData = [];
              this.totalCount = 0;
              this.tableLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.tableLoading = true;
          xz.GetSpecialSubjectList(this.listQuery.subjectOfLegalAffairsId).then(res => {
            if (res.status == 'ok') {
              this.tableData = res.data;
              // this.totalCount = res.data.totalCount;
              this.tableLoading = false;
            } else {
              this.tableData = [];
              // this.totalCount = 0;
              this.tableLoading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      // 获取项目列表
      getProNameList() {
        xz.getplancomrecordprojectlist(this.proNameQuery, localStorage.loginRoletype).then(res => {
          if (res.status == 'ok') {
            this.projectList = res.data
          } else {
            this.projectList = []
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 表格多选
      handleSelectionChange(val) {
        // console.log('yyy',val)
        this.noticeData = val
        this.multipleSelection = val;
      },
      //分页
      handleCurrentChange(val) {
        this.listQuery.pagination.page = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.pagination.page = 1
        this.listQuery.pagination.pageSize = Number(val)
        this.getList()
      },
      // 搜索
      searchHandle() {
        this.listQuery.pagination.page = 1
        this.getList()
      },
      // 获取员工列表
      getMemberList() {
        xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            this.memberList = res.msg
          } else {
            this.memberList = []
          }
        })
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
      },
      addSupLeg() {
        this.subForm = {
          subjectOfLegalAffairsId: '',
          status: 0, //状态1：停用0：启用
          founder: Cookies.get("userid-b")
        }
        this.visibleSupLeg = true;
      },
      editSub(row) {
        this.subForm = {
          subjectOfLegalAffairsId: row.subjectOfLegalAffairsId,
          status: row.status, //状态1：停用0：启用
          founder: Cookies.get("userid-b")
        }
        this.visibleSupLeg = true;
      },
      confirmAddSupLeg() {
        if (this.subForm.subjectOfLegalAffairsId) {
          this.isBtnLoading = true;
          xz.BasicFun(this.subForm, 'PostSpecialSubjectSave').then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功');
              this.isBtnLoading = false;
              this.getList();
              this.visibleSupLeg = false;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
      stopHandleSub(id, status) {
        this.loading = true;
        let d = {
          subjectOfLegalAffairsId: id,
          status,
          founder: Cookies.get("userid-b")
        }
        xz.BasicFun(d, 'PostSpecialSubjectSave').then(res => {
          if (res.status == 'ok') {
            this.$message.success(status == 1 ? '停用成功！' : '启用成功！');
            this.loading = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
      }
    }
  }
</script>

<style scoped>
  .mr15 {
    margin-right: 15px;
  }

  .d_btn_box {
    margin-top: 10px;
  }

  .i_radio_box {
    display: -webkit-box;
    /* align-items: center; */
  }

  .i_box {
    margin-left: 30px;
  }

  .note_txt {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }

  .n_txt {
    text-align: center;
    font-size: 14px;
    color: #409EFF;
  }

  .info_box {
    padding: 5px 10px 20px;
  }

  .info_tab_box {
    padding: 0 10px;
  }

  .info_item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 5px;
  }

  .dec_box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .dec_txt {
    margin-right: 20px;
  }

  .dec_txt .txt01 {
    font-size: 14px;
    color: #000;
    font-weight: bold;
  }

  .dec_txt .txt02 {
    font-size: 14px;
    color: #409EFF;
  }

  .dec_txt .txt03 {
    font-size: 14px;
    color: #303133;
  }

  .com_empty {
    width: 100%;
    padding: 10px;
    color: #666;
    font-size: 14px;
    text-align: center;
  }

  .r_act_item .com_btn {
    background-color: #19bd92;
    border-color: #19bd92;
    color: #fff;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .f_table {
    padding-bottom: 40px;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .c_dlt_icon {
    cursor: pointer;
    font-size: 18px;
    color: #F56C6C;
  }

  .groupname {
    font-size: 14px;
    margin-right: 10px;
  }

  .banlabel {
    color: #c0c4cc;
  }

  .r_l_title {
    font-size: 14px;
    color: #333;
    line-height: 25px;
    font-weight: bold;
    border-bottom: 1px dashed #ddd;
  }

  .form-item input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ccc;
    padding-left: 14px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 10px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  /* 这是主要的，文件上传按钮的样式 */
  .file-btn {
    display: inline-block;
    width: 54px;
    height: 30px;
    background: #fff;
    border: 1px solid #ccc;
    /* border-radius:2px; */
    text-align: center !important;
    line-height: 32px;
    color: #333333;
    /* position: relative;
  top: 5px;
  left: 0; */
    margin-left: 8px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .f_btns {
    display: flex;
    justify-content: flex-end;
  }

  .f_list_item {
    margin-bottom: 10px;
  }

  .f_list_item span {
    margin-right: 10px;
  }

  .r_label_title {
    font-size: 15px;
    color: #409eff;
    font-weight: 500;
    padding-bottom: 10px;
    border-bottom: 1px solid #EBEEF5;
  }

  .r_label_list {
    margin-top: 10px;
  }

  .ftabs {
    background: #fff;
    width: 99%;
  }

  .r_line_box {
    display: flex;
    align-items: center;
  }

  .r_line_txt {
    width: 20px;
    height: 1px;
    background-color: #DCDFE6;
    margin: 0 5px;
  }

  .r_more_box {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
  }

  .r_more_txt {
    display: inline-block;
    width: 50px;
    margin-right: 5px;
    margin-left: 30px;
    font-size: 13px;
    cursor: pointer;
    color: #409eff;
  }

  .r_more_txt i {
    font-size: 14px;
    color: #409eff;
    transition: all 0.3s;
  }

  .rotate-img {
    transform: rotate(270deg);
  }

  .res_dialog_popover {
    display: flex;
    justify-content: flex-end;
  }

  .divide_item {
    margin-bottom: 10px;
    font-size: 14px;
    color: #333
  }

  .pop_list_box .d_txt02,
  .pop_list_box .d_txt03 {
    margin-right: 5px;
  }

  .pop_list_box .d_txt04 {
    color: #409eff;
    font-size: 13px;
    text-decoration: underline;
  }

  .notice_title {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #409eff;
    font-size: 14px;
  }

  .notice_title span {
    cursor: pointer;
  }

  .notice_title i {
    font-size: 16px;
  }
</style>

<style>
  .page_invoiceSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_invoiceSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_invoiceSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_invoiceSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_invoiceSet .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }
</style>